module.exports = __webpack_public_path__ + "assets/search-load.53d8f85005bdad88f865e8167189b810.gif";